import ScalarMenuSupport_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuSupport.vue.script.js";
//#region src/components/ScalarMenu/ScalarMenuSupport.vue
var ScalarMenuSupport_default = ScalarMenuSupport_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuSupport_default as default };

//# sourceMappingURL=ScalarMenuSupport.vue.js.map